
import { computed, defineComponent, PropType, ref, toRef } from "vue";
import VZButton from "./Button.vue";
import VZRating from "./Rating.vue";
import VZFile from "./File.vue";
import VZAttachements from "./Attachements.vue";
import VZInput from "./Input.vue";
import VZPassword from "./Password.vue";
import VZLabel from "./Label.vue";
import VZRadioButton from "./RadioButton.vue";
import VZParagraph from "./Paragraph.vue";
import VZSwitchButton from "./SwitchButton.vue";
import VZCheckbox from "./Checkbox.vue";
import VZTextArea from "./TextArea.vue";
import VZList from "./List.vue";
import VZDivider from "./Divider.vue";
import VZImage from "./Image.vue";
import VZDate from "./Date.vue";
import VZSignature from "./Signature.vue";
import VZCamera from "./Camera.vue";
import VZLKLookup from "./LKLookup.vue";
import VZTimer from "./Timer.vue";
import VZDropMessage from "./DropMessage.vue";
import QrCode from "./QRCode.vue";
import QrCodeValidate from "./QRCodeValidate.vue";
import BarCode from "./BarCode.vue";
import BarCodeValidate from "./BarCodeValidate.vue";

export interface Component {
  component: any;
  name?: string;
  attrs?: Record<string, any>;
  events?: Record<string, (...args: any[]) => void>;
  webId?: string | null;
}

export default defineComponent({
  name: "VZDrawComponent",
  inheritAttrs: false,
  components: {
    // eslint-disable-next-line vue/no-unused-components
    VZButton,
    // eslint-disable-next-line vue/no-unused-components
    VZRating,
    // eslint-disable-next-line vue/no-unused-components
    VZFile,
    // eslint-disable-next-line vue/no-unused-components
    VZAttachements,
    // eslint-disable-next-line vue/no-unused-components
    VZInput,
    // eslint-disable-next-line vue/no-unused-components
    VZDropMessage,
    // eslint-disable-next-line vue/no-unused-components
    VZPassword,
    // eslint-disable-next-line vue/no-unused-components
    VZLabel,
    // eslint-disable-next-line vue/no-unused-components
    VZRadioButton,
    // eslint-disable-next-line vue/no-unused-components
    VZParagraph,
    // eslint-disable-next-line vue/no-unused-components
    VZSwitchButton,
    // eslint-disable-next-line vue/no-unused-components
    VZCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    VZTextArea,
    // eslint-disable-next-line vue/no-unused-components
    VZList,
    // eslint-disable-next-line vue/no-unused-components
    VZDivider,
    // eslint-disable-next-line vue/no-unused-components
    VZImage,
    // eslint-disable-next-line vue/no-unused-components
    VZDate,
    // eslint-disable-next-line vue/no-unused-components
    VZSignature,
    // eslint-disable-next-line vue/no-unused-components
    VZTimer,
    // eslint-disable-next-line vue/no-unused-components
    VZCamera,
    // eslint-disable-next-line vue/no-unused-components
    VZLKLookup,
    // eslint-disable-next-line vue/no-unused-components
    QrCode,
    // eslint-disable-next-line vue/no-unused-components
    QrCodeValidate,
    // eslint-disable-next-line vue/no-unused-components
    BarCode,
    // eslint-disable-next-line vue/no-unused-components
    BarCodeValidate,
  },
  props: {
    component: { type: Object as PropType<Component>, required: true },
    selectControl: { type: String },
    isDraggable: { type: Boolean, default: true },
    isPreview: { type: Boolean, default: false },
  },
  setup(props) {
    const updatedComp = toRef(props, "component");
    const vzAttributes = ref({});
    const STYLES = [
      "padding",
      "fontWeight",
      "defaultFonts",
      "borderWidth",
      "borderStyle",
      "defaultBorder",
      "fontSize",
      "margin",
      "borderColor",
      "borderSize",
      "backgroundColor",
      "fontStyle",
      "textDecoration",
      "color",
      "fontFamily",
    ];
    const computedAttrs = computed(() => {
      const style = updatedComp.value?.attrs?.style;
      const styleKeys = Object.keys(style || {});
      STYLES.forEach((key) => {
        if (!styleKeys.includes(key)) {
          vzAttributes.value[key] = "";
        } else {
          vzAttributes.value[key] = `${style[key]} !important`;
        }
      });
      const attrsKeys = updatedComp.value?.attrs;
      if (attrsKeys) {
        Object.keys(attrsKeys).forEach((key) => {
          if (STYLES.includes(key) && !vzAttributes.value[key]) {
            vzAttributes.value[key] = `${attrsKeys[key]} !important`;
          }
        });
      }
      const attrs = {
        ...updatedComp.value?.attrs,
        style: vzAttributes.value,
      };
      return attrs;
    });
    return { updatedComp, computedAttrs };
  },
});
